
import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/company/about/page'));
const ServicePage = lazy(() => import('../pages/service/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const NewsDetailPage = lazy(() => import('../pages/news/detail/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/company',
    element: <AboutPage />,
  },
  {
    path: '/service',
    element: <ServicePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/news/detail',
    element: <NewsDetailPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
